module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAI1JREFUSA1jYBgFBEKAEVV+lieQP4uB4b8MqjjRvMcMDIzpDAxp22E6mGAMKE2J4SAjZIGOm4lsJgsyB+HydDSfoarCzZv5HygHtAQB0H2AkKESa9QCggE5GkSjQUQwBAgqGE1FBIMIrTRlfAIpUcGlIkHNOBQA6wQEQI+DNGCFAbSEbACtcMjWPxI1AgCelhLbvBio8gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Blue/Checkbox off.png
// module id = 668
// module chunks = 0